export class TaskSupplier {
  constructor(
    public readonly id: string,
    public readonly taskId: string|null,
    public readonly orderId: string|null,
    public readonly projectId: string|null,
    public readonly supplierId: string|null,
    public readonly relationId: string|null,
    public readonly description: string|null,
    public readonly status: string,
    public readonly isComplete: boolean,
  ) {}

  static fromJson(json: any): TaskSupplier {
    return new TaskSupplier(
      String(json['id']),
      json['task_id'],
      json['order_id'],
      json['project_id'],
      json['supplier_id'] ?? null,
      json['relation_id'],
      json['description'],
      json['status'],
      json['is_complete'],
    );
  }
}